import React from 'react';
import VideoCard from '../VideoCard/VideoCard';
import VideoCardSkeleton from '../VideoCard/VideoCardSkeleton';
import { VideoCardData } from '../../types/video-card.types';

interface RelatedVideosProps {
    videos: VideoCardData[];
    isLoading?: boolean;
    onSelect?: (video: VideoCardData) => void;
    layout?: 'grid' | 'rail';
}

const RelatedVideos = ({ videos, isLoading = false, onSelect, layout = 'grid' }: RelatedVideosProps) => {
    const isRail = layout === 'rail';
    const containerClassName = isRail
        ? 'grid gap-4'
        : 'grid gap-6 sm:grid-cols-2 xl:grid-cols-3';
    const cardVariant = isRail ? 'compact' : 'grid';

    if (isLoading) {
        return (
            <div className={containerClassName}>
                {Array.from({ length: 6 }).map((_, index) => (
                    <VideoCardSkeleton key={`related-skeleton-${index}`} variant={cardVariant} />
                ))}
            </div>
        );
    }

    if (videos.length === 0) {
        return (
            <div className="py-6 text-sm text-gray-500">
                No recommendations available yet.
            </div>
        );
    }

    return (
        <div className={containerClassName}>
            {videos.map((video, index) => (
                <VideoCard
                    key={`${video.id}-${index}`}
                    video={video}
                    variant={cardVariant}
                    analyticsContext={{ source: 'related_videos' }}
                    onSelect={onSelect}
                />
            ))}
        </div>
    );
};

export default RelatedVideos;
